import { render } from "./Storages.vue?vue&type=template&id=0263752e"
import script from "./Storages.vue?vue&type=script&lang=js"
export * from "./Storages.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__